import '../DeepAnalysis.less';
import React from 'react';
import { Spin, Icon } from 'antd';

type Props = {
    description?: string;
    style?: React.CSSProperties;
};

export default function LoaderCard({ description, style }: Props) {
    return (
        <div className="deep-analysis-loader-card" style={style}>
            <Spin
                indicator={
                    <Icon
                        data-cy="loader"
                        type="loading"
                        spin
                    />
                }
            />
            {description && <h1>{description}</h1>}
        </div>
    );
}
